// modulo  paginator
// https://github.com/cornflourblue/react-pagination-example
// Css bootstrap https://stackpath.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css
import React from 'react';
import Pagination from "./PaginatorComponent";
import Axios from "axios";
const ASSETS_BASE = /localhost/.test(window.location.href) ? "" : "/global17/bundles/games/dist";
class MainPaginator extends React.Component {
    constructor(props) {
        super(props);

        // an example array of 150 items to be paged
        let exampleItems = [{id:0, name:'dog',razza:'pit-bull'},{id:2, name:'dog',razza:'pastore'},{id:3, name:'dog',razza:'pincher'}]

        /*let exampleItems = [...Array(150).keys()].map( i =>
            ( { id: (i+1), name: 'Item ' + (i+1) } )

        );
*/
        this.state = {
            exampleItems: exampleItems,
            pageOfItems: []
        };

        // bind function in constructor instead of render (https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/jsx-no-bind.md)
        this.onChangePage = this.onChangePage.bind(this);
    }
    componentDidMount() {

        console.log( "PROPS" ,  this.props.dataDogs   )

     /*   Axios.get('https://petpassion.dgthouse.com/confronto-razze/getall').
        then( (data) => {
            let result = data.data.data.number.results ;
            console.log(data.data.data.number.results);
            //pet_breed.name
            this.setState({ exampleItems: result })
        } )*/
        this.setState({ exampleItems: this.props.dataDogs })
    }

    onChangePage(pageOfItems) {
        // update state with new page of items
        this.setState({ pageOfItems: pageOfItems, exampleItems: this.props.dataDogs });
    }

    render() {
        return (
            <div>
                <div className="text-center">
                        <div className={'dog-block'}>  {
                            this.state.pageOfItems.map( (item ,index)=>
                                <div onClick={ () => {
                                        if ( item.article_url == '-' ){
                                            window.location.href = '#'
                                        }else{
                                            window.location.href = item.article_url
                                        }
                                    }
                                } className={"item"}  key={index}>
                                    <img className={'dog-image'} onError={(e)=>{
                                        e.target.src= ASSETS_BASE + "/images/placeholder-s-cani.png"
                                    }}  src={ this.props.pathBaseImage + item.name + '.png'} />
                                    <span className={'dog-name'}> { item.name } </span>
                                </div>
                        )} </div>
                        <Pagination pageSize={9} items={ this.props.dataDogs } onChangePage={ this.onChangePage } />
                </div>
            </div>
        );
    }
}

export default MainPaginator;